import type { ReactElement } from 'react';
import { useMobileAudio } from '../audio/MobileAudioContext';
import { StreamControls } from '../audio/StreamControls';

/**
 * Squawk streams only (FZN Pro + Zeroday).
 * Engines live in MobileAudioProvider (shell-level).
 * WSJ feed lives under the Alerts hub.
 */
export function MobileAudioTab(): ReactElement {
  const {
    steamroom,
    zeroday,
    canSteamroom,
    canZeroday,
    stopAll,
    anyIntended,
  } = useMobileAudio();

  const hasSquawk = canSteamroom || canZeroday;

  if (!hasSquawk) {
    return (
      <div className="p-4 text-center text-gray-400 text-sm">
        No squawk streams on this account. FZN Pro and/or FZN Zeroday access is
        required.
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full min-h-0 overflow-y-auto">
      <div className="px-4 pt-4 pb-2">
        <h1 className="text-lg font-bold text-white">Audio</h1>
        <p className="text-xs text-gray-500 mt-1 leading-relaxed">
          FZN Pro and FZN Zeroday squawk. Playback stays alive when you switch
          tabs. After screen lock, return to the app to reconnect if iOS
          suspended WebRTC.
        </p>
      </div>

      {steamroom && <StreamControls stream={steamroom} />}
      {zeroday && <StreamControls stream={zeroday} />}

      {anyIntended && (
        <div className="p-4">
          <button
            type="button"
            onClick={stopAll}
            className="w-full min-h-[44px] rounded-lg border border-dark-border text-sm font-medium text-gray-300 bg-dark-surface"
          >
            Stop all
          </button>
        </div>
      )}

      <div className="px-4 pb-8 text-[11px] text-gray-600 leading-relaxed">
        Both streams can play at once. Volume 0 mutes and tears down that
        stream&apos;s WebRTC connection. WSJ desk feed is under Alerts → WSJ.
      </div>
    </div>
  );
}
